import { postWithToken, postWithTokenV2 } from 'api/network';

export async function GetContextMenu(txnOppIds, menuLocation) {
    const res = await postWithToken(`/api/appSetting/contextMenu?menuLocation=${menuLocation}`, txnOppIds);
    const data = await res.json();

    const visibleItems = data.filter(item => item.visible);
    const sortedItems = visibleItems.sort((a, b) => a.group - b.group || a.order - b.order);  // Order by Group field then by Order field

    return sortedItems;
}

export async function GetPostAcqContextMenu(taskIds, menuLocation) {
    const data = await postWithTokenV2(`/api/postAcquisition/tasks/taskgrid/contextmenu?menuLocation=${menuLocation}`, taskIds);
    const visibleItems = data.filter(item => item.visible);
    const sortedItems = visibleItems.sort((a, b) => a.group - b.group || a.order - b.order);  // Order by Group field then by Order field

    return sortedItems;
}

/*
Backend item looks like this
public class ContextMenuItemDto
{
    public string Action { get; set; }
    public string ActionDisplayName { get; set; }
    public bool Visible { get; set; }
    public bool Enabled { get; set; }
    public int Group { get; set; }
    public int Order { get; set; }
}
*/